import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-supplier-contracts-filter-form-skeleton',
  imports: [Skeleton],
  templateUrl: './supplier-contracts-filter-form-skeleton.html',
})
export class SupplierContractsFilterFormSkeleton {}
